// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["async.a.d.react-dom-dev","async.a.d.react-bootstrap","async.a.d.motion","initial.react","initial.vendor"], function() { return __webpack_require__("./web/src/js/external_pages/landing.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
